import { SafeServerApi } from "@/services/ServerApi";

export default {
  companyLookup(accountId) {
    return SafeServerApi.post("salesforce-company-lookup", accountId);
  },
  emailAltLookup(email) {
    return SafeServerApi.post("salesforce-email-alt-lookup", email);
  },
  emailLookup(email) {
    return SafeServerApi.post("salesforce-email-lookup", email);
  },
  usernameLookup(cablelabsLogin) {
    return SafeServerApi.post("salesforce-username-lookup", cablelabsLogin);
  },
};
